import React from 'react';
import { humanize } from '@utils';
import { RowWrapper, LeftDiv, RightDiv, CauseText, SubText, CauseWrap } from './styled';

const formatCauseText = ({ dimension, causeTxt }) => (
  <CauseText key={dimension}> {causeTxt} </CauseText>
);

function Row({ alert, searchSummary }) {
  const { maxCumulativeImpactedUniques, values, alertIds } = alert;

  const handleClick = () => {
    searchSummary(alert);
  };

  return (
    <RowWrapper>
      <LeftDiv>
        <CauseWrap onClick={handleClick}>{values.map(formatCauseText)}</CauseWrap>
        <SubText>Peak Impacted Devices {humanize(maxCumulativeImpactedUniques, '')}</SubText>
      </LeftDiv>
      <RightDiv>
        <span>{alertIds.length}</span>
        <SubText>{alertIds.length > 1 ? 'Alerts' : 'Alert'}</SubText>
      </RightDiv>
    </RowWrapper>
  );
}

export default Row;
